var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 19,
    viewBox: "0 0 22 19",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3195 0.761478C22.0029 1.39576 22.0029 2.42414 21.3195 3.05842L12.6834 17.9628C12 18.597 10.778 18.597 10.0946 17.9628L1.3446 9.84186C0.661177 9.20758 0.661177 8.1792 1.3446 7.54492C2.02801 6.91064 3.13605 6.91064 3.81947 7.54492L11.332 14.5174L18.8446 0.761478C19.528 0.127196 20.6361 0.127196 21.3195 0.761478Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c44e02df.svg";
export { ForwardRef as ReactComponent };